<template>
    <el-dialog :title="title" :visible.sync="bankInfoDialog" width="40%" top="15vh" center style="border: 1px solid #01DFD7" :close-on-click-modal = false
               :close-on-press-escape = false @close="closeDialog">
        <el-card>
            <el-form ref="dateForm" label-width="85px" label-position="left" :model="detail">
                <el-row>
                    <el-col :span="12"><el-form-item label="订单编号">{{item.orderId}}</el-form-item></el-col>
                    <el-col :span="12"><el-form-item label="租借时间">{{item.rentTime | formatDate}}</el-form-item></el-col>
                </el-row>
                <el-row>
                    <el-col :span="12"><el-form-item label="用户昵称">{{item.nickName}}</el-form-item></el-col>
                    <el-col :span="12"><el-form-item label="用户电话">{{item.usPhone}}</el-form-item></el-col>
                </el-row>
                <el-row>
                    <el-col :span="12"><el-form-item label="设备编号">{{item.rentPowerBoxId}}</el-form-item></el-col>
                    <el-col :span="12"><el-form-item label="租借槽位">{{item.rentSlot}}</el-form-item></el-col>
                </el-row>
                <el-row>
                    <el-col :span="12"><el-form-item label="门店名称">{{item.storeName}}</el-form-item></el-col>
                    <el-col :span="12"><el-form-item label="门店地区">{{item.area}}</el-form-item></el-col>
                </el-row>
                <el-row>
                    <el-col :span="24"><el-form-item label="门店地址">{{item.address}}</el-form-item></el-col>
                </el-row>
            </el-form>
        </el-card>
    </el-dialog>
</template>
<script>
import { formatDate } from "../../utils/date.js";
export default {
    data() {
        return {
            bankInfoDialog:false,
            item: '',
            title: ''
        }
    },
    methods: {
        init(item){
            this.bankInfoDialog = true;
            this.item = item;
            this.title = item.state === "0" ? "设备正在被租借中！" : "设备已经被购买啦！"
        }
    },
    filters: {
        formatDate(time) {
            var date = new Date(time);
            return formatDate(date, "yyyy-MM-dd hh:mm:ss");
        },
    }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/devicemanagement/bankOrder.vue